//@flow
import type { ReducerState$Type,EditForm$Type } from '../genericFlowTypes'

export const transformDataToEditFormData=(data:any,orion: ReducerState$Type)=>{
    let formData: EditForm$Type = {}
    
    const orionResultsetData = data['orionResultset']
    formData.isInvalidDoc = orionResultsetData['is_invalid_doc']?orionResultsetData['is_invalid_doc']:false
    formData.isOverrideVendorName = orionResultsetData['is_override_vendor_name']?orionResultsetData['is_override_vendor_name']:false
    
    if (orionResultsetData['inv_no']){
        formData.invNo = orionResultsetData['inv_no']
    }
    if (orionResultsetData['inv_date']){
        formData.invDate = orionResultsetData['inv_date']
    }
    if (orionResultsetData['po_no']){
        formData.poNo = orionResultsetData['po_no']
    }
    if (orionResultsetData['location']){
        formData.location = orionResultsetData['location']
    }
    if (orionResultsetData['total']){
        formData.total = parseFloat(orionResultsetData['total'])
    }
    if (orionResultsetData['vendor_name']){
        formData.vendorName = orionResultsetData['vendor_name']
    }
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/orion/editFormData.js